import { DateUtils } from '../../utils/DateUtils';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { Call } from '../models/Call';

export class CallMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Call {
    const timestamp = data.timestamp ? DateUtils.toMoment(data.timestamp) : null;

    return new Call(this.gqlIdEncoder.decode(data.id), timestamp, Boolean(data.isKeptByFilters));
  }
}
